import React, { useEffect } from 'react';
import checkoutBannerImg from '../../utils/assets/checkout/security-radar.png';
import BannerSection from '../../shared/components/BannerSection/BannerSection';
import NavegationInfo from '../../shared/components/NavegationInfo/NavegationInfo';
import PaymentInfo from '../components/PaymentInfo/PaymentInfo';
const Checkout = () => {

    useEffect(()=>{
        window.scroll(0, 0);
    })
    const bannerSectionInfo =
    {
       cardTitle: "Now you can invest in identity protection and security",
       cardButtonText: "",                    
       lengendBackground: checkoutBannerImg
    }

    return (
        <React.Fragment>
           <BannerSection props={bannerSectionInfo}/>
           <NavegationInfo page="Checkout"/>
           <PaymentInfo/>
        </React.Fragment>
    );
};

export default Checkout;
            